import { LOGOUT, AUTH_ERROR } from '../actions/auth';

let parsedUser = null;
try {
  const rawUser = localStorage.getItem('user');
  parsedUser = rawUser ? JSON.parse(rawUser) : null;
} catch (err) {
  console.error('Failed to parse user from localStorage:', err);
  parsedUser = null;
}

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: false,
  user: parsedUser,
  loading: true,
  initialized: false,
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
    case 'REGISTER_SUCCESS':
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.user,
        isAuthenticated: true,
        loading: false,
        error: null,
        initialized: true,
      };

    case AUTH_ERROR:
      return {
        ...state,
        initialized: true,
        loading: false,
        error: action.payload,
      };
    case 'LOGIN_FAIL':
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        initialized: true,
        loading: false,
        error: action.payload,
      };

    case LOGOUT:
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        initialized: true,
        loading: false,
        error: null,
      };

    case 'FORGOT_PASSWORD_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'FORGOT_PASSWORD_SUCCESS':
      return {
        ...state,
        loading: false,
        error: null,
      };

    case 'FORGOT_PASSWORD_FAIL':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case 'RESEND_CONFIRMATION_SUCCESS':
      return {
        ...state,
        loading: false,
        error: null,
      };

    case 'RESEND_CONFIRMATION_FAIL':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case 'AUTH_REFRESHED': {
      const { token, user } = action.payload;

      if (token) localStorage.setItem('token', token);
      if (user) localStorage.setItem('user', JSON.stringify(user));
      return {
        ...state,
        token,
        user,
        isAuthenticated: true,
        loading: false,
        error: null,
      };
    }

    case 'AUTH_BOOTSTRAP_START':
      return { ...state, loading: true, initialized: false };

    case 'AUTH_BOOTSTRAP_DONE':
      return { ...state, loading: false, initialized: true };

    default:
      return state;
  }
};

export default authReducer;
